<template>
  <div class="single-curve">
    <div class="cure-top">
      <div class="cure-top-title">环境温湿度传感器曲线</div>
      <div class="cure-top-select">
        <div style="margin-right: 1vw">
          <DropDownInput type="0" :items="sensorValue" content="" @sendValue="sendValue" @sendInfo="showInfo"></DropDownInput>
        </div>
        <div style="display: flex">
          <div class="input-contain">
            <div class="input-title">X：</div>
            <div class="input-wrapper" style="width: 5vw">
              <input  v-model="historyInfo.siteX"/>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">Y：</div>
            <div class="input-wrapper" style="width: 5vw">
              <input v-model="historyInfo.siteY"/>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">Z：</div>
            <div class="input-wrapper" style="width: 5vw">
              <input v-model="historyInfo.siteZ"/>
            </div>
          </div>
        </div>
        <div class="input-date-wrapper">
          <el-date-picker
            v-model="value"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="query button" @click="buttonSearch">查询</div>
      </div>
    </div>
    <div class="loading-data" v-if="loading">
      <i class="el-icon-loading"></i>
      <div>加载中，请稍后···</div>
    </div>
    <div class="chart-wrapper" v-show="!loading" id="myChart4" v-if="rows.length > 0"></div>
    <div class="none-data" v-if="!loading && rows.length<1">暂无数据</div>
  </div>
</template>

<script>
import DropDown from '../../../../components/DropDownSingle.vue'
import DropDownInput from '../../../../components/DropDownInput.vue'
import {queryRtNodeMonitInfo, queryNodeHistoryInfo, getMaintainData} from '../../../../api/maintain'
import {renderTime} from '../../../../tools/methods'
let echarts = require('echarts')
let myChart4
export default {
  name: 'WareSingleTemHum',
  components: { DropDown, DropDownInput },
  data () {
    return {
      percentage: '',
      rows: [],
      loading: false,
      moduleType: '03',
      nodeType: '03',
      sensorValue: [],
      siteLocation: '',
      value: '',
      historyInfo: {
        endTime: '',
        nodeId: '',
        siteX: '',
        siteY: '',
        siteZ: '',
        startTime: ''
      },
      legendData: [
        {name: '温度', textStyle: {color: '#a84200'}},
        {name: '温度预警值', icon: 'line', textStyle: {color: '#9948a8'}},
        {name: '湿度', textStyle: {color: '#01c5f1'}},
        {name: '湿度预警值', icon: 'line', textStyle: {color: '#ffce29'}}
      ],
      selected: {
        '温度预警值': true,
        '湿度预警值': true
      },
      name_T: '温度/(℃)',
      maxT: '',
      minT: '',
      markLine_T_: '',
      markLine_T: '',

      name_W: '湿度/(%)',
      maxW: '',
      minW: '',
      markLine_W: '',
      markLine_W_: ''
    }
  },
  created () {
    this.handleSearch()
  },
  watch: {
    value: function () {
      console.log(this.value)
      this.historyInfo.startTime = this.value !== null ? this.value[0] : ''
      this.historyInfo.endTime = this.value !== null ? this.value[1] : ''
    }
  },
  methods: {
    buttonSearch: function () {
      this.loading = true
      queryNodeHistoryInfo(this.historyInfo).then(res => {
        res.data.map(item => {
          item.createdTime = renderTime(item.createdTime)
        })
        console.log(res)
        this.rows = res.data
        this.loading = false
        let that = this
        setTimeout(function () {
          that.getCharts()
          myChart4.on('legendselectchanged', function (obj) {
            that.getCharts()
          })
        }, 100)
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    sendValue: function (value) {
      console.log(value)
      this.handleSearch(value)
    },
    showInfo: function (data) {
      this.historyInfo.nodeId = data.nodeId
      console.log(data)
      let body = {
        siteId: data.siteId,
        siteType: data.siteType
      }
      getMaintainData(body).then(res => {
        console.log(res)
        if (res.data !== null) {
          this.legendData = [
            {name: '温度', textStyle: {color: '#a84200'}},
            {name: '温度预警值', icon: 'line', textStyle: {color: '#9948a8'}},
            {name: '湿度', textStyle: {color: '#01c5f1'}},
            {name: '湿度预警值', icon: 'line', textStyle: {color: '#ffce29'}}
          ]
          this.markLine_T = {
            symbol: 'none',
            lineStyle: {type: 'solid', color: '#9948a8'},
            label: {show: false},
            data: [
              {
                name: '',
                yAxis: res.data.stackTempUpper
              },
              {
                name: '',
                yAxis: res.data.stackTempLower
              }
            ]
          }
          this.markLine_T_ = this.markLine_T
          this.maxT = res.data.stackTempUpper + 1
          this.minT = res.data.stackTempLower - 1
          this.markLine_W = {
            symbol: 'none',
            lineStyle: {type: 'solid', color: '#ffce29'},
            label: {show: false},
            data: [
              {
                name: '',
                yAxis: res.data.stackMoistureUpper
              },
              {
                name: '',
                yAxis: res.data.stackMoistureLower
              }
            ]
          }
          this.markLine_W_ = this.markLine_W
          this.maxW = res.data.stackMoistureUpper + 1
          this.minW = res.data.stackMoistureLower - 1
        } else {
          this.legendData = [
            {name: '温度', textStyle: {color: '#a84200'}},
            {name: '湿度', textStyle: {color: '#01c5f1'}}
          ]
          this.markLine_T = ''
          this.markLine_T_ = ''
          this.maxT = ''
          this.minT = ''
          this.markLine_W = ''
          this.markLine_W_ = ''
          this.maxW = ''
          this.minW = ''
        }
      }).catch(err => {
        console.log(err)
      })
    },
    handleSearch: function (value) {
      let body = {
        moduleType: this.moduleType,
        nodeType: this.nodeType,
        nodeId: value
      }
      queryRtNodeMonitInfo(body).then(res => {
        console.log(res)
        this.sensorValue = res.data.rows
      }).catch(err => {
        console.log(err)
      })
    },
    getCharts: function () {
      this.getChart4()
      window.onresize = function () {
        myChart4.resize()
      }
    },
    getChart4: function () {
      console.log(this.rows)
      let date = []
      let value1 = []
      let value2 = []
      let maxT = this.rows[0].airTemp
      let minT = this.rows[0].airTemp
      let maxW = this.rows[0].airMoisture
      let minW = this.rows[0].airMoisture
      if (this.rows.length < 25) {
        this.percentage = 100
      } else {
        this.percentage = 2500 / this.rows.length
      }
      this.rows.map(item => {
        date.push(item.createdTime)
        value1.push(item.airTemp)
        value2.push(item.airMoisture)
        if (item.airTemp > maxT) {
          maxT = item.airTemp
        }
        if (item.airTemp < minT) {
          minT = item.airTemp
        }
        if (item.airMoisture > maxW) {
          maxW = item.airMoisture
        }
        if (item.airMoisture < minW) {
          minW = item.airMoisture
        }
      })
      myChart4 = echarts.init(document.getElementById('myChart4'))
      myChart4.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {type: 'dashed'}
          }
        },
        textStyle: {color: '#ffffff'},
        legend: {
          y: 'top',
          right: '5%',
          orient: 'horizontal',
          itemGap: 50,
          data: this.legendData,
          selected: this.selected
        },
        grid: {
          top: '15%',
          right: '4%',
          left: '4%',
          bottom: '25%'
        },
        xAxis: {
          type: 'category',
          splitLine: {show: false},
          axisTick: false,
          axisLine: {
            lineStyle: {color: '#32b16c'}
          },
          axisLabel: {
            textStyle: {
              fontSize: 8
            },
            interval: 0,
            rotate: 45
          },
          data: date
        },
        yAxis: [
          {
            type: 'value',
            scale: 'true',
            axisTick: false,
            max: this.maxT || maxT + 1,
            min: this.minT || minT - 1,
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ['#2a2f57']
              }
            },
            axisLine: {
              lineStyle: {color: '#32b16c'}
            },
            splitNumber: '5',
            name: this.name_T
          },
          {
            type: 'value',
            scale: 'true',
            max: this.maxW || maxW + 1,
            min: this.minW || minW - 1,
            axisTick: false,
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ['#2a2f57']
              }
            },
            axisLine: {
              lineStyle: {color: '#32b16c'}
            },
            splitNumber: '5',
            name: this.name_W
          }
        ],
        dataZoom: [
          {
            type: 'slider',
            show: false,
            start: 0,
            end: this.percentage,
            handleSize: 8
          },
          {
            type: 'inside',
            start: 0,
            end: this.percentage
          },
          {
            type: 'slider',
            show: false,
            yAxisIndex: 0,
            filterMode: 'empty',
            width: 12,
            height: '70%',
            handleSize: 8,
            showDataShadow: false,
            left: '93%'
          }
        ],
        series: [
          {
            name: '温度预警值',
            type: 'line',
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#9948a8'
                },
                color: '#9948a8'
              }
            }
          },
          {
            name: '湿度预警值',
            type: 'line',
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#ffce29'
                },
                color: '#ffce29'
              }
            }
          },
          {
            name: '温度',
            type: 'line',
            symbol: 'circle',
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#a84200'
                },
                color: '#a84200'
              }
            },
            data: value1,
            markLine: this.markLine_T_
          },
          {
            name: '湿度',
            type: 'line',
            symbol: 'circle',
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#1b84dc'
                },
                color: '#01c5f1'
              }
            },
            data: value2,
            markLine: this.markLine_W_
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
  @import "SingleCure.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/warehouse/singleCurve/WareSingleTemHum.vue